import Layout from "components/Layout";
import { ReactElement } from "react";
import { TermsPage } from "shared-pages";

const Terms = () => <TermsPage />;

Terms.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default Terms;
